// UploadCreateAPI.tsx
import { TableContainer } from '@material-ui/core';
import { Grid, Table, TableBody, TableHead, TablePagination, TableSortLabel, Typography } from '@mui/material';
import React from 'react';
import { UploadCreateAPIProps } from '../../models/APITransationLog/IAPITransationLog';
import Footer from '../Footer/Footer';
import StyledCell from '../GlobalStyles/StyledCell';
import StyledTableRow from '../GlobalStyles/StyledTableRow';
import { StyledTableCell } from '../GlobalStyles/TableStyledCell';
import { useRowStyles } from './APITransactionLogCss';
import ViewMoreCreateAPI from './ViewMoreCreateAPI';
import { format, parseISO } from 'date-fns';
import { useGlobalState } from '../../store/GlobalStore';
import moment from 'moment';

const UploadCreateAPI: React.FC<UploadCreateAPIProps> = ({ uploadCreateAPILogList, totalCreateAPICount, page, rowsPerPage, order, orderBy, onSortChange, onPageChange, onRowsPerPageChange }) => {
    const { state } = useGlobalState();
    const classes = useRowStyles();
    const DateFormat = state.GlobalUtils?.settingValue === 'DD/MM/YYYY' ? 'dd/MM/yyyy' : state.GlobalUtils?.settingValue === 'MM/DD/YYYY' ? 'MM/dd/yyyy' : state.GlobalUtils?.settingValue === 'YYYY/MM/DD' ? 'yyyy/MM/dd' : 'MM/dd/yyyy';

    const handleSort = (property: string) => {
        const isAsc = orderBy === property && order === 'asc';
        const newOrder = isAsc ? 'desc' : 'asc';
        onSortChange(property, newOrder);
    };

    const headCells = [
        { id: 'clientNo', label: 'CLIENT CODE' },
        { id: 'clT_NAME_1', label: 'CLIENT NAME' },
        { id: 'account_no', label: 'ACCOUNT NO' },
        { id: 'firstName_ResponsibleParty', label: 'FIRST NAME' },
        { id: 'lastName_ResponsibleParty', label: 'LAST NAME' },
        { id: 'phase', label: 'PHASE' },
        { id: 'totalDue', label: 'TOTAL DUE' },
        { id: 'referralDate', label: 'REFERRAL DATE' },
        { id: 'createdDate', label: 'CREATED DATE' },
        { id: 'invoiceDate', label: 'INVOICE DATE' },
        { id: 'actions', label: 'ACTIONS' },
    ];

    return (
        <Grid container spacing={0}>
            <Grid item xs={12}>
                <TableContainer className={`${classes.tableBody} scrollbox on-scrollbar`}>
                    <Table stickyHeader>
                        <TableHead>
                            <StyledTableRow>
                                {headCells.map((headCell) => (
                                    <StyledTableCell key={headCell.id} sortDirection={orderBy === headCell.id ? order : false} className={classes.tableHeaderStyle} >
                                        {headCell.id !== 'actions' ? (
                                            <TableSortLabel
                                                active={orderBy === headCell.id}
                                                direction={orderBy === headCell.id ? order : 'asc'}
                                                onClick={() => handleSort(headCell.id)}
                                            >
                                                {headCell.label}
                                            </TableSortLabel>
                                        ) : (
                                            headCell.label
                                        )}
                                    </StyledTableCell>
                                ))}
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {uploadCreateAPILogList?.map((row, index) => (
                                <StyledTableRow key={index}>
                                    <StyledCell className={classes.tableCellBody}>{row?.clientNo ?? ''}</StyledCell>
                                    <StyledCell className={classes.tableCellBody}>{row?.clT_NAME_1 ?? ''}</StyledCell>
                                    <StyledCell className={classes.tableCellBody}>{row?.accountNumber ?? ''}</StyledCell>
                                    <StyledCell className={classes.tableCellBody}>{row?.firstName_ResponsibleParty ?? ''}</StyledCell>
                                    <StyledCell className={classes.tableCellBody}>{row?.lastName_ResponsibleParty ?? ''}</StyledCell>
                                    <StyledCell className={classes.tableCellBody}>{row?.phase ?? ''}</StyledCell>
                                    <StyledCell className={classes.tableCellBody}>{row?.totalDue ?? ''}</StyledCell>
                                    <StyledCell className={classes.tableCellBody}>
                                        {row?.referralDate ? format(parseISO(row?.referralDate), DateFormat) : ''}
                                    </StyledCell>
                                    <StyledCell className={classes.tableCellBody}>
                                        {row?.createdDate ? moment(row.createdDate).format(state.GlobalUtils?.settingValue) : ''}
                                    </StyledCell>
                                    <StyledCell className={classes.tableCellBody}>
                                        {row?.invoiceDate ? moment(row.invoiceDate).format(state.GlobalUtils?.settingValue) : ''}
                                    </StyledCell>
                                    <StyledCell className={classes.tableCellBody}>
                                        <ViewMoreCreateAPI row={row} />
                                    </StyledCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                    {uploadCreateAPILogList?.length === 0 ?
                        <Typography variant="h6" fontSize={15} color={'red'} gutterBottom marginTop={1}>
                            No records to display..
                        </Typography>
                        : null}
                </TableContainer>
            </Grid>
            <Grid container spacing={0}>
                <Grid item xs={6}>
                    <div className="footer">
                        <Footer />
                    </div>
                </Grid>
                <Grid item xs={5}>
                    <TablePagination
                        rowsPerPageOptions={[25, 50, 100]}
                        component="div"
                        count={totalCreateAPICount}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={(event, newPage) => onPageChange(newPage)}
                        onRowsPerPageChange={(event) => {
                            const newRowsPerPage = parseInt(event.target.value, 10);
                            onRowsPerPageChange(newRowsPerPage);
                        }}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default UploadCreateAPI;
